import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/network/")({
    beforeLoad: () => {
        throw redirect({ to: "/dashboard/network/users" });
    },
});
